<mat-nav-list>
    @for (menuItem of menuItems; track menuItem.label) {
        <div class="item-container">
            <pixl-menu-item
                [item]="menuItem"
                [collapsed]="sideNavCollapsed()"
                [subItemCounter]="0"
            />
        </div>
    }
</mat-nav-list>
